module.exports = __webpack_public_path__ + "img/nap_thumb_3.2ce2744f.jpg";